/* @flow weak */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'CREATE_ACTIVITY',
  'EDIT_ACTIVITY',
  'CLOSE_ACTIVITY',
  'LOAD_ACTIVITIES',
  'LOAD_ACTIVITY',
  'GET_TRANSACTIONS',
  'GET_RECIPIENTS',
  'UPDATE_RSVP',
]);



// WEBPACK FOOTER //
// ./src/payments/constants/ActivityConstants.js